/**
 * Returns a number whose value is limited to the given range.
 */
export const clamp = (number: number, min: number, max: number) => {
  if (number <= min) return min;
  if (number >= max) return max;

  return number;
};
